import { gql } from '@reverbdotcom/commons/src/gql';

// All-matches bulk actions on the CoreQL dashboard, scoped by the page's searchUrlParams
export const SELLER_DASHBOARD_BULK_ACTION_MUTATION = gql(`
  mutation SellerDashboardBulkAction(
    $input: SellerDashboardBulkActionInput!
  ) {
    sellerDashboardBulkAction(input: $input) {
      enqueued
      message
    }
  }
`);
